type SunriseMarkProps = {
  size?: number;
  color?: string;
  twoLine?: boolean;
};

export function SunriseMark({ size = 28, color, twoLine = true }: SunriseMarkProps) {
  const c = color ?? "var(--accent)";
  const ratio = twoLine ? 0.72 : 0.65;
  const h = Math.round(size * ratio);
  return (
    <svg
      width={size}
      height={h}
      viewBox="0 0 40 30"
      fill="none"
      aria-hidden="true"
      style={{ display: "block", flexShrink: 0 }}
    >
      <path d="M5 22 A 15 15 0 0 1 35 22" stroke={c} strokeWidth="2.2" strokeLinecap="round" fill="none" />
      <line x1="2" y1="25.5" x2="38" y2="25.5" stroke="var(--text)" strokeWidth="1.4" strokeLinecap="round" />
      {twoLine && (
        <line x1="7" y1="28.8" x2="33" y2="28.8" stroke="var(--text)" strokeWidth="1" strokeLinecap="round" opacity="0.5" />
      )}
    </svg>
  );
}
